import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { Container } from 'react-bootstrap';
import Loader from 'react-loader';
import UserDashboard from './Components/UserDashboard';
import Pulse from './Components/Pulse';
import ProfileScript from './Components/ProfileScript';
import Dashboard from './Components/Dashboard';
import DashboardPulse from './Components/DashboardPulse';
import Login from './Components/Login';
import Signup from './Components/Signup';
import RecoverPassword from './Components/RecoverPassword';
import FiterNavbar from './Components/FiterNavbar';
import FiterKanban from './Components/FiterKanban';
import FiterCV from './Components/FiterCV';
import FiterAPI from './fiterAPI';
// import MyCourses from './Pages/MyCourses';
import MyCourses from './Pages/MyCourses';
import fiterAPI from './fiterAPI';
import GeneralPanel from './Pages/GeneralPanel';

class App extends React.Component {
  constructor() {
    super();
    this.state = {
      courses: [],
      students: [],
      currentUser: undefined,
      currentInstitution: undefined,
      abstentions: [],
      loaded: false,
      currentPulse: {},
      usersList: {},
      areasList: []
    };

    this.setCurrentUser = this.setCurrentUser.bind(this);
    this.removeCurrentUser = this.removeCurrentUser.bind(this);
    this.turnOnLoading = this.turnOnLoading.bind(this);
    this.turnOffLoading = this.turnOffLoading.bind(this);
  }

  async componentDidMount() {
    this.setState({
      courses: await FiterAPI.getAllCourses(),
      institutions: await FiterAPI.getAllInstitutions(),
      // students: await FiterAPI.getStudents(),
      currentUser: await FiterAPI.getCurrentUser(),
      currentInstitution: await FiterAPI.getInstitution(),
      // abstentions: await FiterAPI.getAbstentions({}),
      currentPulse: await FiterAPI.getCurrentPulse(),
      getStudability: FiterAPI.getStudability,
      getUsersList: FiterAPI.getUsersByInstituition
      // usersList: await FiterAPI.getUsersByInstituition(),
    });
    try {
      this.setState({
        userRoles: this.state.currentUser && this.state.currentUser.roles,
        areasList: await FiterAPI.getAreas({ forCurrentUser: false }),
        areasData: await FiterAPI.getUsersByArea()
      });
    } catch { }
    this.setState({ loaded: true });
  }

  async setCurrentUser() {
    this.setState({ loaded: false });
    this.setState({
      currentUser: await FiterAPI.getCurrentUser(),
      currentInstitution: await FiterAPI.getInstitution(),
      currentPulse: await FiterAPI.getCurrentPulse()
    });
    this.setState({ loaded: true });
  }

  turnOnLoading() {
    this.setState({ loaded: false });
  }

  turnOffLoading() {
    this.setState({ loaded: true });
  }

  async removeCurrentUser() {
    this.setState({ loaded: false });
    await FiterAPI.loggout();
    await this.setCurrentUser();
  }

  render() {
    const {
      courses,
      institutions,
      students,
      currentUser,
      loaded,
      currentPulse,
      currentInstitution,
      abstentions,
      getStudability,
      usersList,
      getUsersList,
      areasList,
      userRoles
    } = this.state;
    return (
      <>
        <FiterNavbar
          currentUser={currentUser}
          removeCurrentUser={this.removeCurrentUser}
          getStudability={getStudability}
        />
        <Container>
          <Loader loaded={loaded}>
            <Route
              exact
              path="/"
              render={() =>
                currentUser ? (
                  <Pulse
                    // courses={courses}
                    students={students}
                    savePulse={FiterAPI.savePulse}
                    currentPulse={currentPulse}
                    currentUser={currentUser}
                    currentInstitution={currentInstitution}
                  />
                ) : (
                  <Login setCurrentUser={this.setCurrentUser} />
                )
              }
            />
            <Route
              exact
              path="/login"
              render={() =>
                currentUser ? (
                  <Pulse
                    // courses={courses}
                    // students={students}
                    savePulse={FiterAPI.savePulse}
                    currentPulse={currentPulse}
                    currentUser={currentUser}
                    currentInstitution={currentInstitution}
                  />
                ) : (
                  <Login setCurrentUser={this.setCurrentUser} />
                )
              }
            />
            <Route
              exact
              path="/recuperar-senha"
              render={() =>
                currentUser ? (
                  <Pulse
                    // courses={courses}
                    // students={students}
                    savePulse={FiterAPI.savePulse}
                    currentPulse={currentPulse}
                    currentUser={currentUser}
                    currentInstitution={currentInstitution}
                  />
                ) : (
                  <RecoverPassword />
                )
              }
            />
            <Route
              exact
              path="/cadastro"
              render={() =>
                currentUser ? (
                  <Redirect to="/" />
                ) : (
                  <Signup
                    setCurrentUser={this.setCurrentUser}
                    courses={courses}
                    institutions={institutions}
                  />
                )
              }
            />
            <Route
              path="/roteiro"
              render={() =>
                currentUser == null ||
                  currentUser.roleName !== 'Coordinator' ? (
                  <Redirect to="/" />
                ) : (
                  <ProfileScript
                    courses={courses}
                    currentUser={currentUser}
                    currentInstitution={currentInstitution}
                  />
                )
              }
            />
            <Route
              exact
              path="/dashboard"
              render={() =>
                currentUser == null ||
                  currentUser.roleName !== 'Coordinator' ? (
                  <Redirect to="/" />
                ) : (
                  <Dashboard
                    courses={courses}
                    getAnswers={FiterAPI.getAnswers}
                  />
                )
              }
              onEnter={this.requireAuth}
            />
            <Route
              path="/pulso"
              render={() =>
                currentUser == null ? (
                  <Redirect to="/" />
                ) : (
                  <Pulse
                    courses={courses}
                    // students={students}
                    savePulse={FiterAPI.savePulse}
                    currentPulse={currentPulse}
                    currentUser={currentUser}
                    currentInstitution={currentInstitution}
                  />
                )
              }
            />
            <Route
              exact
              path="/dashboard-pulse"
              render={() =>
                currentUser == null ||
                  currentUser.roleName !== 'Coordinator' ? (
                  <Redirect to="/" />
                ) : (
                  <DashboardPulse
                    currentInstitution={currentInstitution}
                    currentUser={currentUser}
                    courses={courses}
                    getUnits={FiterAPI.getUnits}
                    getPulses={FiterAPI.getPulses}
                    getAllPulsesByMonth={FiterAPI.getAllPulsesByMonth}
                    getAbstentions={fiterAPI.getAbstentions}
                    // usersList={usersList}
                    getUsersList={getUsersList}
                  />
                )
              }
            />
            <Route
              exact
              path="/user"
              render={() =>
                currentUser == null ? (
                  <Redirect to="/" />
                ) : (
                  <UserDashboard
                    currentInstitution={currentInstitution}
                    getPulsesForUser={FiterAPI.getPulsesForUser}
                    currentUser={currentUser}
                    courses={courses}
                    turnOnLoading={this.turnOnLoading}
                    turnOffLoading={this.turnOffLoading}
                    setCurrentUser={this.setCurrentUser}
                    areasList={areasList}
                  />
                )
              }
            />
            <Route
              exact
              path="/board/:areaId/:monthFilter"
              render={() =>
                currentUser == null ? (
                  <Redirect to="/" />
                ) : (
                  <FiterKanban
                    currentInstitution={currentInstitution}
                    currentUser={currentUser}
                    courses={courses}
                    getUserHistory={fiterAPI.getUserHistory}
                  />
                )
              }
            />
            <Route
              exact
              path="/cv/:userId"
              render={props => (
                <FiterCV
                  {...props}
                  turnOnLoading={this.turnOnLoading}
                  turnOffLoading={this.turnOffLoading}
                />
              )}
            />
            {/* <Route
              exact
              path="/cursos"
              render={() =>
                currentUser == null ? <Redirect to="/" /> : <MyCourses />
              }
            /> */}
            <Route
              exact
              path="/cursos"
              render={() =>
                currentUser == null ? (
                  <Redirect to="/" />
                ) : (
                  <MyCourses
                    listAreas={fiterAPI.listAreas}
                    getAreas={fiterAPI.getAreas}
                    getAbstentions={fiterAPI.getAbstentions}
                  />
                )
              }
            />
            <Route
              exact
              path="/general-panel"
              render={() =>
                currentUser == null ||
                  userRoles.indexOf('Super Admin') === -1 ? (
                  <Redirect to="/" />
                ) : (
                  <GeneralPanel />
                )
              }
            />
          </Loader>
        </Container>
      </>
    );
  }
}

export default App;
